import WhatsAppIcon from "@/components/icons/WhatsAppIcon";
import { trackWhatsAppClick } from "@/lib/analytics";

const WHATSAPP_PHONE = "50360651263";
const WHATSAPP_MESSAGE = "Hola, estoy interesado en conocer más sobre Compaws y sus servicios.";

const WhatsAppBubble = () => {
  const href = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <div className="fixed z-50 bottom-[88px] right-6 md:bottom-6 md:right-[88px] group">
      {/* Tooltip */}
      <span
        className="pointer-events-none absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-lg bg-foreground text-background text-sm font-poppins px-3 py-1.5 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity"
      >
        Contáctanos
      </span>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackWhatsAppClick("floating_bubble")}
        aria-label="Contáctanos por WhatsApp"
        title="Contáctanos"
        className="flex items-center justify-center rounded-full shadow-lg transition-transform hover:scale-110"
        style={{
          backgroundColor: "#25D366",
          color: "#ffffff",
          width: "56px",
          height: "56px",
        }}
      >
        <WhatsAppIcon size={30} />
      </a>
    </div>
  );
};

export default WhatsAppBubble;
